import * as Icon from "@ant-design/icons";
import { Modal, Row, Col, Form, Tag, Flex } from "antd";
import Search from "antd/lib/input/Search";
import type { ColumnsType, TableProps } from "antd/es/table";
import { useState, useEffect } from "react";
import { setTitle } from "../../redux/slices/configuracoes/configuracoesSlice";
import { useAppDispatch, useAppSelector } from "../../util/hooks";
import { buscarTipoDocumento, deletarTipoDocumento } from "../../services/tipoDocumentoService";
import { setBuscaTipoDocumento, setEntityTipoDocumento, setModalCadastrarTipoDocumento, setModalDeletarTipoDocumento } from "../../redux/slices/tipoDocumento/tipoDocumentoSlice";
import { TipoDocumentoModel } from "../../models/tipoDocumento/tipoDocumentoModel";
import { FilterValue } from "antd/es/table/interface";
import CadastroEdicaoTipoDocumento from "./modals/cadastrar";
import { ItemMenuAcoes } from "../../models/sistema/itemMenuAcoes";
import AcoesComponent from "../../components/table/acoesComponent";
import { ButtonComponent } from "../../components/button/cadastrar";
import TableComponent from "../../components/table/tableComponent";
import MensagemModal from "../../components/modal/mensagem";

const TipoDocumento = () => {
  //estados globais
  const tipoDocumentoState = useAppSelector((state) => state.tipoDocumento);

  //estados locais
  const [filteredInfo, setFilteredInfo] = useState<Record<string, FilterValue | null | string>>({});

  const editar = Object.values(tipoDocumentoState.entity).length !== 0;

  //hooks
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setTitle("TIPO DOCUMENTO"));
    dispatch(buscarTipoDocumento(tipoDocumentoState.busca));
  }, []);

  const goCadastrar = () => {
    dispatch(setEntityTipoDocumento({}));
    dispatch(setModalCadastrarTipoDocumento(true));
  };

  const goEditar = (value: TipoDocumentoModel) => {
    dispatch(setEntityTipoDocumento(value));
    dispatch(setModalCadastrarTipoDocumento(true));
  };

  const closeModalCadastro = () => {
    dispatch(setModalCadastrarTipoDocumento(false));
  };

  const goDeletar = (value: TipoDocumentoModel) => {
    dispatch(setEntityTipoDocumento(value));
    dispatch(setModalDeletarTipoDocumento(true));
  };

  const closeModalDeletar = () => {
    dispatch(setModalDeletarTipoDocumento(false));
  };

  const onSearch = (value: string) => {
    dispatch(setBuscaTipoDocumento(value));
    dispatch(buscarTipoDocumento(value));
  };

  const onChange: TableProps<TipoDocumentoModel>["onChange"] = (pagination, filters, sorter, extra) => {
    setFilteredInfo(filters);
  };

  const items: ItemMenuAcoes[] = [
    {
      label: "Editar",
      key: "1",
      icon: <Icon.EditOutlined />,
      function: (item: any) => goEditar(item),
    },
    {
      label: "Remover",
      key: "2",
      icon: <Icon.DeleteOutlined />,
      function: (item: any) => goDeletar(item),
    },
  ];

  const columns: ColumnsType<TipoDocumentoModel> = [
    {
      title: "DENOMINAÇÃO",
      dataIndex: "denominacao",
      sorter: (a, b) => a.denominacao.localeCompare(b.denominacao),
      sortDirections: ["ascend", "descend", "ascend"],
    },
    {
      title: "DESCRIÇÃO",
      dataIndex: "descricao",
      sorter: (a, b) => a.descricao.localeCompare(b.descricao),
      sortDirections: ["ascend", "descend", "ascend"],
    },
    {
      title: "TIPO",
      align: "center",
      width: 100,
      filters: [
        {
          text: "Receita",
          value: "receita" as any,
        },
        {
          text: "Despesa",
          value: "despesa" as any,
        },
      ],
      onFilter: (_, record: any) => {
        let verifica: any = Object.keys(filteredInfo).length;
        if (verifica !== 0) {
          let chaves: any = Object.values(filteredInfo)[0];
          if (chaves !== null) {
            if (chaves.length === 2) {
              return record.despesa || record.receita;
            } else {
              return chaves[0] === "despesa" ? record.despesa : record.receita;
            }
          } else {
            return record;
          }
        }
        return record.receita;
      },
      render: (_, record) => (
        <Flex justify="center" gap={4}>
          {record.receita && <Tag>Receita</Tag>}
          {record.despesa && <Tag>Despesa</Tag>}
        </Flex>
      ),
    },
    {
      title: "AÇÕES",
      dataIndex: "acoes",
      align: "center",
      width: 75,
      render: (_, record) => <AcoesComponent record={record} items={items} />,
    },
  ];

  return (
    <Flex vertical>
      <Form layout="vertical">
        <Row gutter={12} align="bottom">
          <Col span={20}>
            <Flex gap={12}>
              <Form.Item label="Pesquisar">
                <Search allowClear placeholder="Denominação" onSearch={onSearch} className="searchInput" style={{ width: 300 }} enterButton />
              </Form.Item>
            </Flex>
          </Col>
          <Col span={4}>
            <Flex justify="end">
              <ButtonComponent onClick={goCadastrar} />
            </Flex>
          </Col>
        </Row>
      </Form>
      <TableComponent data={tipoDocumentoState.list} columns={columns} loading={tipoDocumentoState.loading} tableProps={{ onChange: onChange }} />
      <Modal title={editar ? "EDITAR TIPO DOCUMENTO" : "NOVO TIPO DOCUMENTO"} centered width={900} open={tipoDocumentoState.modalCadastrar} onCancel={closeModalCadastro} footer={null} destroyOnHidden>
        <CadastroEdicaoTipoDocumento />
      </Modal>
      <Modal title={"REMOVER TIPO DOCUMENTO"} centered width={350} open={tipoDocumentoState.modalDeletar} onCancel={closeModalDeletar} footer={null} destroyOnHidden>
        <MensagemModal
          text="Deseja remover o tipo de documento?"
          action={deletarTipoDocumento({ value: tipoDocumentoState.entity.id, busca: tipoDocumentoState.busca })}
          close={setModalDeletarTipoDocumento(false)}
        />
      </Modal>
    </Flex>
  );
};

export default TipoDocumento;
